module.exports = __webpack_public_path__ + "media/images/coupon/used-343d6eb06585de8754a878fea37ebc97.png";